import reusedStyles from "../styles.module.scss";
import styles from "./styles.module.scss";

export default function Future() {
	return (
		<div className={`${styles.section}`}>
			<div className={`container ${styles.container}`}>
				<h2 className={reusedStyles.heading}>Do You Dare To Step Into The Future With Honda</h2>
				<p className={reusedStyles.paragraph}>Honda RoadSync is intuitive to use, featuring voice recognition input, voice feedback, and a 4-way toggle switch located on the left handlebar. With your phone safely in your pocket, you can stay connected and focus on the road, making every ride enjoyable and hassle-free.</p>
			</div>
		</div>
	);
};